<p>
  No Area of Interest filter will be applied, and all data will be shown for the entire state.
</p>